import React from 'react';
import { motion } from 'framer-motion';
import { MenuItem as MenuItemType } from '../data/menu';
import { Plus } from 'lucide-react';

interface MenuItemProps {
  item: MenuItemType;
}

const MenuItem: React.FC<MenuItemProps> = ({ item }) => {
  return (
    <motion.div 
      className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 group"
      whileHover={{ y: -5 }}
    >
      <div className="relative h-48 overflow-hidden">
        <img 
          src={item.image} 
          alt={item.name} 
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-between p-4">
          <span className="text-white font-bold text-lg">{item.price}</span>
        </div>
      </div>
      
      <div className="p-5">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-lg font-bold text-gray-800 line-clamp-2 flex-1 mr-2">{item.name}</h3>
          <span className="text-purple-700 font-bold bg-purple-50 px-2 py-1 rounded-lg text-sm whitespace-nowrap">
            {item.price}
          </span>
        </div>
        
        {item.description && (
          <p className="text-gray-500 text-sm mb-4 line-clamp-2">{item.description}</p>
        )}
        
        <button className="w-full mt-2 py-2 border border-purple-600 text-purple-600 rounded-lg hover:bg-purple-600 hover:text-white transition-colors flex items-center justify-center gap-2 font-medium text-sm">
          <Plus size={16} />
          Tambah Pesanan
        </button>
      </div>
    </motion.div>
  );
};

export default MenuItem;
